import { inject, Injectable } from '@angular/core';

import { WidgetsService } from 'components/organisms/widgets-loader/widgets.service';

/**
 * Resolves an empty widget list for the `/live-preview/` route.
 *
 * The route has no page data of its own — everything arrives over postMessage after the first
 * render — so `markNoWidgets()` is what stops `waitForWidgets()` in `bootstrap.ts` from waiting for
 * widgets that will never be resolved on the server.
 */
@Injectable({ providedIn: 'root' })
export class LivePreviewViewResolverService {
    private readonly widgetsService = inject(WidgetsService);

    public resolve(): Promise<[]> {
        this.widgetsService.markNoWidgets();

        return Promise.resolve([]);
    }
}
